import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * A help page body. `help:<page-id>` links open that page in the same panel or Help Centre
 * (crs-doc/help/README.md); other links open in a new tab.
 */
const HelpMarkdown: React.FC<{ markdown: string; onOpenPage: (pageId: string) => void }> = ({ markdown, onOpenPage }) => (
  <div className="help-markdown">
    <ReactMarkdown
      urlTransform={(url) => url}
      components={{
        a: ({ href, children }) => {
          if (href?.startsWith('help:')) {
            const id = href.slice(5);
            return (
              <a href={`#help-${id}`} onClick={(e) => { e.preventDefault(); onOpenPage(id); }}>{children}</a>
            );
          }
          return <a href={href} target="_blank" rel="noreferrer">{children}</a>;
        },
      }}
    >
      {markdown}
    </ReactMarkdown>
  </div>
);

export default HelpMarkdown;
